<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Risk Department</strong>
    </span>
  </div>
  <div class="card-block watermark">
    <div class="row">
      <div class="col-lg-12">
        <button type="button" class="btn btn-primary btn-sm mb-3" data-target="#departmentMasterModal"
          (click)="showGetEntityListDetails()"
          [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/addEvaluationQuestion', 'method':'post', 'menu': 'EvaluationQuestion' }">
          Add Department
        </button>
        <div class="table-responsive table-bordered margin-bottom-50">
          <table datatable [dtOptions]="dtOptions" id="riskDepartmentTable" [dtTrigger]="dtTrigger"
            class="table table-hover compact cell-border nowrap table-striped dataTable" style="background: transparent"
            width="100%">
            <thead>
              <tr>
                <th style="width:5%">Sr. No.</th>
                <th style="width:10%">Risk Description</th>
                <th style="width:65%">Risk Department</th>
                <th
                  [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/editEvaluationQuestion', 'method':'put', 'menu': 'EvaluationQuestion' }">
                  Edit</th>
                <th
                  [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/deleteEvaluationQuestion', 'method':'delete', 'menu': 'EvaluationQuestion' }">
                  Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let department of departmentMasterList;let count=index">
                <td style="text-align:center;width:5%">{{count + 1}}</td>
                <td style="width:10%">{{department.EvaluationCriteriaID.EvaluationCriteria}}</td>
                <td style="width: 65%;word-wrap: break-word;white-space:normal">{{department.RiskDepartment.trim()}}
                </td>
                <td style="width: 5%;text-align: center;color: #74708d;cursor: pointer;"
                  (click)="editQuestionDetails(department)"
                  [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/editEvaluationQuestion', 'method':'put', 'menu': 'EvaluationQuestion' }">
                  <div class="fa fa-pencil"></div>
                </td>
                <td style="
                    width: 5%;
                    text-align: center;
                    color: #74708d;
                    cursor: pointer;
                  " data-target="#deleteQuestionMasterModal" [appHasPermission]="{
                    Url: '/api/v1/secure/boardEvaluationQuestion/deleteEvaluationQuestion',
                    method: 'delete',
                    menu: 'EvaluationQuestion'
                  }" (click)="deleteQuestionIdToPass(department)">
                  <div class="fa fa-trash-o"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Modal for adding new Role-->
        <div class="modal fade" id="departmentMasterModal" tabindex="-1" role="dialog"
          aria-labelledby="departmentMasterModalLabel">
          <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header" style="justify-content: unset !important">
                <h4 class="modal-title" id="departmentMasterModalLabel">
                  Add Department
                </h4>
                <button type="button" class="close" style="right: 5px; position: absolute" data-dismiss="modal"
                  (click)="closeForm()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <form [formGroup]="departmentForm">
                  <div class="row pt-1 pb-1">
                    <label class="col-md-4">Risk Description <sup style="color: red">*</sup>:</label>
                    <div class="col-sm-8">
                      <select class="form-control" [formControl]="departmentForm.controls['evaluationCriteria']">
                        <option value="">Select</option>
                        <option *ngFor="
                            let evaluationCriteriaData of evaluationevalCriteriaList
                          " value="{{ evaluationCriteriaData._id }}">
                          {{ evaluationCriteriaData.EvaluationCriteria }}
                        </option>
                      </select>
                      <div *ngIf="
                          departmentForm.controls['evaluationCriteria'].hasError(
                            'required'
                          ) &&
                          departmentForm.controls['evaluationCriteria'].touched
                        " class="form-control-error-custom">
                        Select Risk Description
                      </div>
                    </div>
                  </div>
                  <div class="row pt-1 pb-1">
                    <label class="col-md-4">Department <sup style="color: red">*</sup>:</label>
                    <div class="col-sm-8">
                      <textarea placeholder="Enter Department text" class="form-control" name="RiskDepartment"
                        (keyup)="departmentFormRiskDepartmentChange($event)"
                        (change)="departmentFormRiskDepartmentChange($event)"
                        [formControl]="departmentForm.controls['RiskDepartment']" type="text"></textarea>
                      <div *ngIf="
                          departmentForm.controls['RiskDepartment'].hasError(
                            'required'
                          ) && departmentForm.controls['RiskDepartment'].touched
                        " class="form-control-error-custom">
                        Department text is required
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer">
                <div style="width: 100%; text-align: left">
                  <span style="color: #ff0000">*</span> Indicates Mandatory
                  field
                </div>
                <button type="button" class="btn btn-primary btn-sm"
                  [disabled]="!departmentForm.valid || disableSavebutton" (click)="submitQuestionDetails()">
                  Save
                </button>
                <button type="button" class="btn btn-default btn-sm"
                  style="background-color: #ffffff; color: #acb7bf !important" data-dismiss="modal"
                  (click)="closeForm()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="editingQuestionModal" tabindex="-1" role="dialog"
          aria-labelledby="editQuestionMasterModalLabel">
          <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header" style="justify-content: unset !important">
                <h4 class="modal-title" id="editQuestionMasterModalLabel">
                  Edit Department
                </h4>
                <button type="button" class="close" style="right: 5px; position: absolute" data-dismiss="modal"
                  (click)="closeForm()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <form [formGroup]="editdepartmentForm">
                  <div class="row pt-1 pb-1">
                    <label class="col-md-4">Risk Description <sup style="color: red">*</sup>:</label>
                    <div class="col-sm-8">
                      <select class="form-control" [formControl]="editdepartmentForm.controls['editEvaluationCriteria']"
                        [(ngModel)]="editCriteriaId">
                        <option value="">Select</option>
                        <option *ngFor="
                            let evaluationCriteriaData of evaluationevalCriteriaList
                          " value="{{ evaluationCriteriaData._id }}" (change)="editCriteria($event)">
                          {{ evaluationCriteriaData.EvaluationCriteria }}
                        </option>
                      </select>
                      <div *ngIf="
                          editdepartmentForm.controls[
                            'editEvaluationCriteria'
                          ].hasError('required') &&
                          editdepartmentForm.controls['editEvaluationCriteria']
                            .touched
                        " class="form-control-error-custom">
                        Select risk description
                      </div>
                    </div>
                  </div>
                  <div class="row pt-1 pb-1">
                    <label class="col-md-4">Department <sup style="color: red">*</sup>:</label>
                    <div class="col-sm-8">
                      <textarea placeholder="Enter Question text" class="form-control" name="RiskDepartment"
                        (keyup)="editRiskDepartmentChange($event)" (change)="editRiskDepartmentChange($event)"
                        [formControl]="editdepartmentForm.controls['editDepartmentText']" type="text"></textarea>
                      <div
                        *ngIf="editdepartmentForm.controls['editDepartmentText'].hasError('required') && editdepartmentForm.controls['editDepartmentText'].touched"
                        class="form-control-error-custom">
                        Department text is required
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer">
                <div style="width: 100%; text-align: left">
                  <span style="color: #ff0000">*</span> Indicates Mandatory
                  field
                </div>
                <button type="button" class="btn btn-primary btn-sm"
                  [disabled]="!editdepartmentForm.valid || disableupdatebutton" (click)="udpateQuestionDetails()">
                  Update
                </button>
                <button type="button" class="btn btn-default btn-sm"
                  style="background-color: #ffffff; color: #acb7bf !important" data-dismiss="modal"
                  (click)="closeForm()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="deleteQuestionMasterModal" tabindex="-1" role="dialog"
          aria-labelledby="deleteQuestionMasterModalLabel">
          <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header" style="justify-content: unset !important">
                <h4 class="modal-title" id="deleteQuestionMasterModalLabel">
                  Delete Department
                </h4>
                <button type="button" class="close" style="right: 5px; position: absolute" data-dismiss="modal"
                  (click)="closeForm()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">Are you sure you want to delete ?</div>

              <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="deleteQuestionDetails()">
                  Delete
                </button>
                <button type="button" class="btn btn-default btn-sm"
                  style="background-color: #ffffff; color: #acb7bf !important" data-dismiss="modal"
                  (click)="closeForm()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        <app-alert></app-alert>
        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
          style="top: 50px; z-index: 9999">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div id="alertPopUpTitle" class="modal-header"
                style="font-size: 20px; font-weight: bold; padding: 5px 15px"></div>
              <div class="modal-body" style="padding: 10px 15px">
                <div id="alertMessage" style="font-size: 16px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>